import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import ServiceMasjidDevelopment from '../../components/ServiceMasjidDevelopment'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'


const ServiceMasjidDevelopmentPage =() => {
    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Service'} pagesub={'Service'}/>
            <ServiceMasjidDevelopment/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ServiceMasjidDevelopmentPage;
